import { defineComponent, h } from 'vue';
import BaseFieldsetComponent from './baseFieldsetMixin.jsx';
import utils from '../../../Shared/utils.jsx';

export default defineComponent({
    name: 'sform-conditional',
    mixins: [BaseFieldsetComponent],
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    methods: {

    },
    render() {
        if (!this.form)
            return null;


        return (
            <table width="100%">
                {this.generateElements(h, this.form, this.layouttype)}
            </table>
        );
    }
});